export enum AnalyticsEvent {
  FreeToPaidUpsellPromptCancelled = 'Free_Prompt_Cancelled',
  FreeToPaidUpsellPromptFreeSelected = 'Free_Prompt_Freemium_Selected',
  FreeToPaidUpsellPromptPaidSelected = 'Free_Prompt_Paid_Selected',
  UpgradeContractRequestViewed = 'upgradeContractRequestViewed',
  UpgradeContractRequested = 'upgradeContractRequested',
  UpgradeContractRequestConfirmation = 'upgradeContractRequestConfirmation',
  UserLogin = 'userLogin',
  UserLoaded = 'userLoaded',
}
